import cardConfirmRequest from "../components/shared/models/card-confirmation-req.json";
import moment from "moment";

export const getConfirmRequest = ({
  formData,
  sessionID,
  eventID,
  productType,
  language,
  flowInd,
  deviceIp,
  deviceType,
  xForwardedFor,
  sourceURL = window.location.href,
  userAgent = navigator.userAgent,
  eventName = "CustomerEvent",
  eventTimestamp = moment().format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
}) => {
  const req = cardConfirmRequest[0];
  req.confirmCardRequest.language = language;
  req.confirmCardRequest.flowInd = flowInd;
  req.confirmCardRequest.partner = productType;
  // Device Information
  req.confirmCardRequest.deviceInfo.deviceIp = deviceIp;
  req.confirmCardRequest.deviceInfo.deviceType = deviceType;
  // Browser Information
  req.confirmCardRequest.browserInfo.sessionId = sessionID;
  req.confirmCardRequest.browserInfo.sourceURL = sourceURL;
  req.confirmCardRequest.browserInfo.userAgent = userAgent;
  req.confirmCardRequest.browserInfo.xForwardedFor = xForwardedFor;
  // EventData Information
  req.confirmCardRequest.eventData.eventId = eventID;
  req.confirmCardRequest.eventData.eventName = eventName;
  req.confirmCardRequest.eventData.eventTSP = eventTimestamp;
  // FormData Information
  req.confirmCardRequest.formData.pan = formData.ccNumber.replace(/ /g, "");
  req.confirmCardRequest.formData.cvv2 = formData.cvv;
  req.confirmCardRequest.formData.dob = formData.dob;
  req.confirmCardRequest.formData.last4SSN = formData.ssn;
  req.confirmCardRequest.formData.pageNumber = "1";

  return req;
};